import { Controller } from "@hotwired/stimulus"

// Toggles password field visibility and swap show/hide icon.
export default class extends Controller {
  static targets = ["input", "toggle", "iconShow", "iconHide"];

  toggle() {
    const input = this.inputTarget;
    const isPassword = input.type === "password";
    input.type = isPassword ? "text" : "password";
    this.iconShowTarget.classList.toggle("hidden", !isPassword);
    this.iconHideTarget.classList.toggle("hidden", isPassword);
  }
}
